import { useState } from "react";
import { Box, Typography, Grid, TextField, Paper } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import AppButton from "../../components/shared/AppButton/AppButton";

const TrackGrievance = () => {
  const [grievanceId, setGrievanceId] = useState("");
  const [error, setError] = useState("");

  const handleSearch = () => {
    if (!grievanceId.trim()) {
      setError("Grievance ID is required");
      return;
    }

    setError("");
    console.log("Tracking Grievance ID:", grievanceId);

    // 🔗 API call will go here later
  };

  return (
    <Box sx={{ px: { xs: 2, md: 4 }, py: 6 }}>
      <Grid container justifyContent="center">
        {/* Responsive Wrapper */}
        <Grid item xs={12} md={8} lg={6}>
          <Paper
            sx={{
              p: { xs: 2.5, md: 4 },
              borderRadius: 3,
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
            }}
          >
            {/* Title */}
            <Typography variant="h5" fontWeight={600} mb={1}>
              Track Your Grievance
            </Typography>

            {/* Subtitle */}
            <Typography color="text.secondary" mb={4}>
              Enter your grievance ID to check the status of your submission.
            </Typography>

            {/* Input + Button */}
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} md={9}>
                <TextField
                  fullWidth
                  label="Grievance ID *"
                  placeholder="Enter your grievance ID (e.g., GRV...)"
                  value={grievanceId}
                  onChange={(e) => setGrievanceId(e.target.value)}
                  error={!!error}
                  helperText={error}
                />
              </Grid>

              <Grid item xs={12} md={3}>
                <AppButton
                  label="Search"
                  fullWidth
                  onClick={handleSearch}
                  sx={{
                    height: "56px",
                    fontSize: "1rem",
                    background: "linear-gradient(90deg, #000000, #1f2937)",
                  }}
                >
                  <SearchIcon />
                </AppButton>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default TrackGrievance;
